import { render, staticRenderFns } from "./xiyatu.vue?vue&type=template&id=cf352b4e&scoped=true"
import script from "./xiyatu.vue?vue&type=script&lang=js"
export * from "./xiyatu.vue?vue&type=script&lang=js"
import style0 from "./xiyatu.vue?vue&type=style&index=0&id=cf352b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf352b4e",
  null
  
)

export default component.exports